import { render, staticRenderFns } from "./TwoMap.vue?vue&type=template&id=5cf1b144&scoped=true"
import script from "./TwoMap.vue?vue&type=script&lang=js"
export * from "./TwoMap.vue?vue&type=script&lang=js"
import style0 from "./TwoMap.vue?vue&type=style&index=0&id=5cf1b144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf1b144",
  null
  
)

export default component.exports